<template>
  <v-container>
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
        <v-toolbar-title>Inscrição - Eleitor</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout md9>
          <v-flex
            md9
            xm12
            sm12
            lg12
          >
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-container>
                <v-layout
                  wrap
                  align-center
                >
                  <v-flex sm3>
                    <v-text-field
                      v-model="eleitor.nu_cpf"
                      label="*CPF"
                      append-icon="account_circle"
                      :rules="[rules.required, rules.cpfMin]"
                      :error-messages="nomeEleitorError"
                      mask="###.###.###-##"
                      required
                    />
                  </v-flex>
                  <v-flex sm5>
                    <v-text-field
                      v-model="eleitor.no_nome"
                      :disabled="true"
                      label="*Nome completo"
                      append-icon="perm_identity"
                      :error-messages="nomeEleitorError"
                      :rules="[rules.cpfInvalido]"
                      required
                    />
                  </v-flex>
                  <v-flex sm2>
                    <v-text-field
                      v-model="eleitor.nu_rg"
                      label="*RG"
                      counter
                      maxlength="11"
                      append-icon="account_circle"
                      :rules="[rules.required]"
                      mask="###########"
                      required
                    />
                  </v-flex>
                  <v-flex sm2>
                    <v-text-field
                      v-model="eleitor.nu_telefone"
                      label="*Telefone"
                      append-icon="phone"
                      placeholder="(99) 99999-9999"
                      mask="(##) #####-####"
                      :rules="[rules.required, rules.phoneMin]"
                      required
                    />
                  </v-flex>
                </v-layout>

                <v-layout
                  wrap
                  align-center
                >
                  <v-flex sm6>
                    <v-text-field
                      v-model="eleitor.ds_email"
                      label="*E-mail"
                      append-icon="mail"
                      placeholder="email@exemplo.com"
                      :rules="[rules.required, rules.email]"
                      counter
                      maxlength="250"
                      required
                    />
                  </v-flex>
                  <v-flex sm6>
                    <v-text-field
                      v-model="eleitor.ds_email_confirmacao"
                      label="*Confirmar e-mail"
                      append-icon="mail"
                      placeholder="email@exemplo.com"
                      :rules="[rules.required, rules.email, rules.emailMatch(email, emailConfirmation)]"
                      counter
                      maxlength="250"
                      required
                    />
                  </v-flex>
                </v-layout>

                <v-layout
                  wrap
                  align-center
                  class="mb-4"
                >
                  <v-flex sm4>
                    <template activator="{ on }">
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        lazy
                        transition="scale-transition"
                        :close-on-content-click="false"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="eleitor.dt_nascimento"
                            label="*Data de Nascimento"
                            :rules="[rules.required, rules.dataAniversario]"
                            append-icon="event"
                            placeholder="ex: 01/12/2019"
                            return-masked-value
                            mask="##/##/####"
                            required
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="date"
                          locale="pt-BR"
                          scrollable
                        >
                          <v-spacer />
                          <v-btn
                            flat
                            color="primary"
                            @click="menu = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            flat
                            color="primary"
                            @click="$refs.menu.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </template>
                  </v-flex>
                  <v-flex sm4>
                    <v-select
                      v-model="eleitor.st_estrangeiro"
                      :items="[{ st_estrangeiro: '0' , nome: 'Brasileiro'},
                               { st_estrangeiro: '1' , nome: 'Estrangeiro'}]"
                      item-value="st_estrangeiro"
                      item-text="nome"
                      label="*Nacionalidade"
                      append-icon="place"
                      :rules="[rules.required]"
                      required
                      box
                    />
                  </v-flex>


                  <v-flex
                    sm4
                  >
                    <v-text-field
                      v-model="eleitor.endereco.nu_cep"
                      label="*CEP"
                      append-icon="my_location"
                      placeholder="99999-999"
                      mask="#####-###"
                      :rules="[rules.required, rules.cepMin]"
                      required
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      v-model="eleitor.endereco.ds_logradouro"
                      label="*Logradouro"
                      append-icon="place"
                      counter
                      maxlength="250"
                      :rules="[rules.required]"
                      required
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm3
                  >
                    <v-text-field
                      v-model="eleitor.endereco.ds_complemento"
                      counter
                      maxlength="250"
                      label="Complemento"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm3
                  >
                    <v-text-field
                      v-model="eleitor.endereco.no_bairro"
                      counter
                      maxlength="250"
                      label="*Bairro"
                      :rules="[rules.required]"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm3
                  >
                    <v-select
                      v-model="eleitor.endereco.co_ibge"
                      :items="listaUF"
                      label="*UF"
                      append-icon="place"
                      item-value="co_ibge"
                      item-text="no_uf"
                      :rules="[rules.required]"
                      required
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm5
                  >
                    <v-select
                      v-model="eleitor.endereco.co_municipio"
                      :items="listaMunicipios"
                      label="*Cidade"
                      append-icon="place"
                      item-value="co_municipio"
                      item-text="no_municipio"
                      :rules="[rules.required]"
                      :disabled="eleitor.endereco.co_ibge < 1 || eleitor.endereco.co_ibge == null"
                    />
                  </v-flex>
                  <v-flex xs12 sm2 offset-sm1>
                    <v-card>
                      <v-card-title v-if="!fileLoaded">
                        <v-avatar class="mx-auto">
                          <v-icon
                            size="80"
                          >
                            person_outline
                          </v-icon>
                        </v-avatar>
                      </v-card-title>
                      <v-card-text>
                        <file
                          v-model="eleitor_foto_rosto"
                          max-file-size="100MB"
                          max-files="1"
                          label-idle="Anexar foto do eleitor"
                          :accepted-file-types="acceptedFileTypes"
                          @input="fileAdded()"
                        />
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>


                <v-btn to="/">
                  Cancelar
                </v-btn>


                <v-btn
                  :disabled="!valid"
                  color="primary"
                  @click="validate"
                >
                  Salvar
                </v-btn>
              </v-container>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import File from '@/core/components/upload/File';
import { eventHub } from '@/event';
import Validate from '../../shared/util/validate';
import moment from 'moment'; 

export default {
  name: 'Eleitor',
  components: { File },
  data: () => ({
    nomeEleitorError: '',
    valid: false,
    date: '',
    dateFormatted: '',
    menu: false,
    headers: [
      {
        text: 'Tipo',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Arquivo',
        align: 'center',
        sortable: false,
      },
      {
        sortable: false,
      },
    ],
    eleitor: {
      nu_cpf: '',
      no_nome: '',
      nu_rg: '',
      nu_telefone: '',
      dt_nascimento: '',
      st_estrangeiro: '',
      ds_email: '',
      ds_email_confirmacao: '',
      endereco: {
        co_ibge: '',
        ds_complemento: '',
        nu_cep: '',
        ds_logradouro: '',
        no_bairro: '',
        co_municipio: '',
      },
      anexos: [],
    },
    listaUF: [],
    listaMunicipios: [],
    email: '',
    emailConfirmation: '',
    eleitor_foto_rosto: {},
    acceptedFileTypes:  [
      'image/jpeg',
      'image/png',
    ],
    fileLoaded: false,
    rules: {
      required: value => !!value || 'Campo não preenchido',
      cpfInvalido: value => !!value || 'CPF não encontrado',
      phoneMin: value => (value && value.length >= 9) || 'Mínimo de 9 caracteres',
      cpfMin: value => (value && value.length === 11) || 'Mínimo de 11 caracteres',
      cepMin: v => (v && v.length === 8) || 'Mínimo de 8 caracteres',
      email: (value) => {
        // eslint-disable-next-line
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'E-mail invalido';
      },
      emailMatch: (email, emailConfirmation) => email === emailConfirmation || 'Os emails não correspondem',
      dataAniversario: (date) => {
        if (date.length === 0 || !date.trim()) {
          return false;
        }

        if (!moment(date).isValid) {
          return 'Data inválida';
        }
        
        const age = moment().diff(date, 'years');

        if (age < 18) {
          return 'É necessário ser maior de 18 anos';
        }

        return true;
      },
    },
  }),
  watch: {
    date() {
      this.eleitor.dt_nascimento = this.formatDate(this.date);
    },
    estadosGetter() {
      this.listaUF = this.estadosGetter;
    },
     municipiosGetter() {
      this.listaMunicipios = this.municipiosGetter;
    },
    'eleitor.endereco.co_ibge': function (coIBGE) {
      this.obterMunicipios(coIBGE);
    },
    'eleitor.nu_cpf': function (value) {
      const self = this;
      self.eleitor.no_nome = '';
      this.nomeEleitorError = 'CPF inválido';
      if (value.length === 11 && Validate.isCpfValido(value)) {
        this.consultarCPF(value).then((response) => {
          const { data } = response.data;
          self.eleitor.no_nome = data.nmPessoaFisica;
        });
        this.nomeEleitorError = '';
      }
    },
    fases() {
      this.checkSubscription();
    }
  },
  mounted() {

    if (Object.keys(this.eleitorGetter).length > 0) {
      this.eleitor = this.eleitorGetter;
    }
    this.obterEstados();
  },
  computed: {
    ...mapGetters({
      fases: 'fase/fases',
      estadosGetter: 'localidade/estados',
      municipiosGetter: 'localidade/municipios',
      eleitorGetter: 'eleitor/eleitor',
      ativarInscricaoEleitor: 'fase/ativarInscricaoEleitor',
    }),
  },
  methods: {
    ...mapActions({
      confirmarEleitor: 'eleitor/confirmarEleitor',
      obterEstados: 'localidade/obterEstados',
      obterMunicipios: 'localidade/obterMunicipios',
      consultarCPF: 'pessoa/consultarCPF',
    }),
    validate() {
      this.eleitor.anexos = [];
      const anexos = [
        'eleitor_foto_rosto',
      ];

      anexos.forEach((nomeAnexo) => {
        if (
          nomeAnexo === 'eleitor_foto_rosto'
          && Object.values(this[nomeAnexo]).length === 0)
        {
          return;
        }

        this.eleitor.anexos.push({
          tp_arquivo: nomeAnexo,
          no_extensao: this[nomeAnexo].fileExtension,
          no_mime_type: this[nomeAnexo].fileType,
          no_arquivo: this[nomeAnexo].filename,
          arquivoCodificado: this[nomeAnexo].getFileEncodeBase64String(),
        });
      });

      if (this.$refs.form.validate()) {
        this.confirmarEleitor(this.eleitor).then(() => {
          this.$router.push('/eleitor/revisao-eleitor');
        });
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    reset() {
      this.$refs.form.reset();
    },
    checkSubscription() {
        if (!this.ativarInscricaoEleitor) {
            eventHub.$emit('eventoErro', 'Período de inscrição encerrado!');
            this.$router.push('/');
        }
    },
    fileAdded(value) {
      this.fileLoaded = !this.fileLoaded;
    }
  },
};
</script>
